// extracted by mini-css-extract-plugin
export var Copyright = "Footer-module--Copyright--oWdip";
export var Footer = "Footer-module--Footer--+ZePN";
export var Logo = "Footer-module--Logo--sXcM6";
export var SubMenu = "Footer-module--SubMenu--PkKPW";